
// others
var _ = require("lodash");

export const filterConfigData = (configData: any) => {
  if (!Array.isArray(configData) || configData.length === 0) {
    return {}; // always return an object instead of undefined
  }

  const configDataCopy = configData.reduce((acc, curr) => ({ ...acc, ...curr }), {});

  // handle requiredDocumentsListwithAttibutes
  if (configDataCopy?.requiredDocumentsListwithAttibutes) {
    const configuredDocuments = Object.entries(configDataCopy.requiredDocumentsListwithAttibutes).map(
      ([key, value]: [string, any]) => ({
        ...value,
        status: "pending",
        checked: true,
        type: key,
      }),
    );

    configDataCopy.configuredDocuments = configuredDocuments;
  }

  // handle nationality list
  if (Array.isArray(configDataCopy?.nationalityList)) {
    configDataCopy.nationalityList = filterArray(configDataCopy.nationalityList);
  }

  // handle booking docs
  if (configDataCopy?.requiredBookingDocumentsList) {
    configDataCopy.requiredBookingDocumentsList = _.map(configDataCopy.requiredBookingDocumentsList, (value, key) => ({
      value: key,
      label: value,
    }));
  }

  return configDataCopy;
};

const filterArray = (data: any) => {
  return _.map(data, (item: string) => ({
    label: item,
    value: item.toLowerCase(),
  }));
};

export const filteLandlordUsers = (data: any) => {
  return _.map(data, (item: any) => ({
    label: item.name,
    value: item.userId,
  }));
};

export const tracker = [
  {
    active: true,
    complete: false,
    title: "Tenant",
    label: "Personal information",
  },
  {
    active: false,
    complete: false,
    title: "Lease Terms",
    label: "Rental agreement details",
  },
  {
    active: false,
    complete: false,
    title: "Payment Plans",
    label: "Options for rent payment",
  },
  {
    active: false,
    complete: false,
    title: "Documents",
    label: "Required paperwork",
  },
];

const isEmptySignatoryUser = (value: unknown) =>
  value == null || (typeof value === "object" && Object.keys(value as object).length === 0);

export const filterBookingDetails = (data: any, bookingForm?: any) => {
  let dataCopy: any = { ...bookingForm, ...data };
  let torPersist = localStorage?.getItem("torType");

  // API payloads often send signatoryUser: null on partial updates; spreading overwrites local draft data.
  if (isEmptySignatoryUser(dataCopy.signatoryUser) && !isEmptySignatoryUser(bookingForm?.signatoryUser)) {
    dataCopy.signatoryUser = bookingForm.signatoryUser;
  }

  const {
    isSignatory,
    signatoryUser,
    tenantDetails,
    leaseTerms,
    bookingTerms,
    leaseManager,
    paymentPlan,
    commercialPaymentPlan,
    requiredDocuments,
    furnished,
    parkings,
    numberOfOcupants,
    invoicingPattern,
  } = dataCopy;
  if (tenantDetails) {
    dataCopy = {
      email: tenantDetails?.email,
      name: tenantDetails?.tenantNameEN,
      externalAgent: dataCopy?.externalAgent,
      arabicName: tenantDetails?.tenantNameAR,
      nationality: tenantDetails?.nationality, //RESIDENTIAL
      maritalStatus: tenantDetails?.maritalStatus, //RESIDENTIAL
      designation: tenantDetails?.designation || tenantDetails?.designationAsPerVisa, //COMMERCIAL
      company: tenantDetails?.company, //COMMERCIAL
      numberOfOcupants: numberOfOcupants ?? tenantDetails?.numberOfOcupants,
      mobile: tenantDetails?.mobileNumber?.substr(tenantDetails?.mobileNumber.length - 9),
      countryCode: tenantDetails?.countryCode, // Country code for mobile number
      workPhone: tenantDetails?.workPhone, // Work phone number
      firstName: tenantDetails?.tenantFirstNameEN || tenantDetails?.firstName, // First name - map from API field
      lastName: tenantDetails?.tenantLastNameEN || tenantDetails?.lastName, // Last name - map from API field
      isBlocked: tenantDetails?.isBlocked === "yes" ? true : false,
    };
  }
  if (leaseManager) dataCopy = { ...dataCopy, ...{ leaseManager: leaseManager.userId } };
  if (leaseTerms) dataCopy = { ...dataCopy, ...{ leaseTerms } };
  if (bookingTerms) dataCopy = { ...dataCopy, ...{ bookingTerms } };
  if (Array.isArray(paymentPlan) ? paymentPlan.length > 0 : Boolean(paymentPlan))
    dataCopy = { ...dataCopy, ...{ paymentPlan } };
  if (Array.isArray(commercialPaymentPlan) ? commercialPaymentPlan.length > 0 : Boolean(commercialPaymentPlan))
    dataCopy = { ...dataCopy, ...{ commercialPaymentPlan } };
  if (requiredDocuments) dataCopy = { ...dataCopy, ...{ requiredDocuments } };
  if (furnished) dataCopy = { ...dataCopy, ...{ furnished } };
  if (signatoryUser) dataCopy = { ...dataCopy, ...{ signatoryUser } };
  if (isSignatory) dataCopy = { ...dataCopy, ...{ isSignatory } };
  if (parkings) dataCopy = { ...dataCopy, ...{ parkings } };
  if (torPersist) dataCopy["torType"] = torPersist;
  if (invoicingPattern) dataCopy = { ...dataCopy, ...{ invoicingPattern } };
  return dataCopy;
};
